import React from 'react';
import classNames from 'classnames';
import createMarkup from 'utils/createMarkup';

const HTMLBlock: React.SFC<PropDef> = ({ html, className }) => (
  <div
    dangerouslySetInnerHTML={createMarkup(html)}
    className={classNames(className, 'rich-text')}
  />
);

interface PropDef {
  html: string;
  className?: string;
}

export default HTMLBlock;

